import { styled } from '../../../base';

export const StepIconRoot = styled('div')<{ isCompleted?: boolean }>(
    ({ theme, isCompleted }) => ({
        zIndex: 2,
        color: isCompleted ? theme.palette.primary.main : 'transparent',
        width: 40,
        height: 40,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        border: `2px solid ${theme.palette.primary.main}`,
        position: 'relative',
        fontWeight: 600,
    })
);
